module.exports = __webpack_public_path__ + "img/slider-1.f1bc7cf6.png";